module.exports = __webpack_public_path__ + "img/delete.bf53f74e.svg";